// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__VoL2f","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3E8OL"};